import { all, put, takeLatest } from "redux-saga/effects";

import { trackEngagement } from "helpers/analytics";
import { IEntityCreateFailure, IEntityUpdateFailure } from "store/entities/actions";
import { MailboxesActionsNames } from "store/entities/mailboxes/actions";
import { ReplyAddressActionsNames } from "store/entities/reply-addresses/actions";
import { RulesActionsNames } from "store/entities/rules/actions";
import { PlanLimitExceededSource } from "store/entities/subscriptions";
import { TEAM } from "store/entities/teams";
import { IActionWithPayload } from "store/helper";

import { SubscriptionViewActions } from "./actions";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* openUpsellModal(action: IActionWithPayload<string, IEntityCreateFailure | IEntityUpdateFailure>) {
  if (action.payload?.errorObject?.type === "planLimitExceeded") {
    trackEngagement("Plan limit exceeded: upsell modal opened", undefined, { source: action.type });
    yield put(
      SubscriptionViewActions.openUpsellModal({
        source: action.type as PlanLimitExceededSource,
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* subscriptionViewSagas() {
  yield all([
    takeLatest(
      [
        TEAM.CREATE.FAILURE,
        MailboxesActionsNames.CREATE.FAILURE,
        ReplyAddressActionsNames.CREATE.FAILURE,
        RulesActionsNames.CREATE.FAILURE,
        RulesActionsNames.UPDATE.FAILURE,
      ],
      openUpsellModal
    ),
  ]);
}
